const akunBankData = [
  {
    type: 'VISA',
    namaBank: 'Bank KB Bukopin',
    namaNasabah: 'Nasabah 1',
    nomorAkhir: '0987',
    curr: 'IDR',
  },
  {
    type: 'VISA',
    namaBank: 'City Bank, NA',
    namaNasabah: 'Nasabah 2',
    nomorAkhir: '5225',
    curr: 'USD',
  },
];

export default akunBankData;
